/**
 * Fetch component wrapper.
 * Checks preloaded state and fetches data when necessary
 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

class FetchDataPage extends PureComponent {
    /**
     * Constructor method
     * Create initial state of component
     * Takes data from window.PRELOADED_STATE if it exists
     * and matches current path,
     * after - deletes it from window object.
     * @param props Object
     */
    constructor(props) {
        super(props);

        let data = [];
        let loading = true;
        const { path, childComponent } = this.props.route;

        if (window.PRELOADED_STATE &&
            window.PRELOADED_STATE.key === path) {
            data = window.PRELOADED_STATE.data;
            loading = false;

            delete window.PRELOADED_STATE;
        }

        this.state = {
            loading,
            data,
            childComponent
        };
    }

    /**
     * fetch data if nothing is already loading
     */
    componentDidMount() {
        if (this.state.loading) {
            this.fetchData(this.props.route.url);
        }
    }

    /**
     * fetch data only if route changed
     * @param nextRoute Object { route }
     */
    componentWillReceiveProps({ route: nextRoute }) {
        if (nextRoute.path !== this.props.route.path) {
            const { childComponent, url } = nextRoute;
            this.setState({
                loading: true,
                data: [],
                childComponent
            });
            this.fetchData(url);
        }
    }

    /**
     * fetchData
     * Method for fetching data
     * @param url string
     */
    fetchData(url) {
        axios.get(url)
            .then(({ data }) => {
                this.setState({
                    loading: false,
                    data
                });
            })
            .catch(error =>
                console.warn(error)
            );
    }

    render() {
        const { loading, data, childComponent: Component } = this.state;

        return <Component loading={loading} data={data} />;
    }
}
/**
 * Prop types validation
 * route passed auto-magically by react-router
 * @type {{route: *}}
 */
FetchDataPage.propTypes = {
    route: PropTypes.shape({
        path: PropTypes.string.isRequired,
        childComponent: PropTypes.func.isRequired,
        url: PropTypes.string.isRequired
    }).isRequired
};

export default FetchDataPage;




// WEBPACK FOOTER //
// ./src/js/common/FetchDataPage.js